exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".play-icon {\r\n    position: absolute;\r\n    display: block;\r\n    top: 25%;\r\n    left: 50%;\r\n    transform: translateX(-50%) translateY(-50%);\r\n    z-index: 2;\r\n    border-radius: 50%;\r\n    background-color: rgba(255, 255, 255, 0.6);\r\n    background-clip: padding-box;\r\n    outline: none;\r\n    padding: 32px;\r\n}\r\n\r\n.play-icon i {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translateX(-47%) translateY(-50%);\r\n    color: #000;\r\n}", ""]);

// exports
